export default "__VITE_ASSET__Cq7_UvlU__"